module.exports = __webpack_public_path__ + "img/地图.dd813362.png";